@if (error) {
  <div class="error-box">
    <div>
      <ul class="error-list">
        <li class="error-message">{{ error }}</li>
        <li class="error-message">
          <a href="/">{{ "common.retry" | transloco }}</a>
        </li>
      </ul>
    </div>
  </div>
} @else {
  @if (!initialized()) {
    <app-fullscreen-loader
      [message]="'app.loading' | transloco"
      [subMessage]="loadingMessage()"
    />
  } @else {
    @if (!loggedIn()) {
      <app-introduction-screen />
    } @else {
      <router-outlet />
    }
  }
}
